export default __webpack_public_path__ + "static/media/09_snail.ee789986.JPG";